// Application types

const REVENUE_PAYOUT_SETTINGS = {
  LOADING_REVENUE_PAYOUT: "LOADING_REVENUE_PAYOUT",
  ALL_REVENUE_PAYOUT: "ALL_REVENUE_PAYOUT",
  SEARCHING: "SEARCHING",
  SEARCH_REVENUE_PAYOUT: "SEARCH_REVENUE_PAYOUT",
  SHOW_REVENUE_PAYOUT: "SHOW_REVENUE_PAYOUT",
  GET_MY_REVENUE_PAYOUT: "GET_MY_REVENUE_PAYOUT",
  FILTERING_REVENUE_PAYOUT: "FILTERING_REVENUE_PAYOUT",
  FILTER_REVENUE_PAYOUT: "FILTER_REVENUE_PAYOUT",
  EDIT_REVENUE_PAYOUT: "EDIT_REVENUE_PAYOUT",
  DOWNLOADING: "DOWNLOADING",
  APPROVING_REVENUE_PAYOUT: "APPROVING_REVENUE_PAYOUT",
};

export default REVENUE_PAYOUT_SETTINGS;
